import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Container,
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  Notifications as NotificationIcon,
  QrCode as QrCodeIcon,
  Edit as EditIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import NotificationsTab from './NotificationsTab';
import PWATab from './PWATab';
import StockManagementTab from './StockManagementTab';
import JobSchedulerTab from './JobSchedulerTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 1, py: 0.5 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

const Admin: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AdminIcon color="primary" />
          Admin Panel
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage notifications, PWA settings, stock data, and background jobs
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            aria-label="admin tabs"
            variant="fullWidth"
          >
            <Tab 
              icon={<NotificationIcon />} 
              label="Notifications" 
              {...a11yProps(0)} 
            />
            <Tab 
              icon={<QrCodeIcon />} 
              label="PWA" 
              {...a11yProps(1)} 
            />
            <Tab 
              icon={<EditIcon />} 
              label="Stock Management" 
              {...a11yProps(2)} 
            />
            <Tab 
              icon={<ScheduleIcon />} 
              label="Job Scheduler" 
              {...a11yProps(3)} 
            />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <NotificationsTab />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <PWATab />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <StockManagementTab />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <JobSchedulerTab />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default Admin;


